import React, { useContext, useEffect, useRef, useState } from 'react'
import ImageGallery from '../common/ImageGallery';

export default function AviatorPage() {
        const [liveCasinoApi, setLiveCasino] = useState();
        const token = sessionStorage.getItem("token");

        useEffect(() => {
          callAPI("All", "Aviator");
        }, []);
    
        const callAPI = (name, type) => {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", `Bearer ${token}`);
    
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
          };
    
          fetch(`${process.env.REACT_APP_BASE_URL}/new_royalcasino?provider=${name}&type=${type}`, requestOptions)
            .then(async (response) => {
              let paresData = await response.json();
              setLiveCasino(paresData.games);
              console.log("live_casino - ", paresData);
            })
            .catch((error) => {
              console.log(error);
            });
        };
  
        return (
            <div className='content-box casino aviator-grid'>
                <div className="right-content">
                    {liveCasinoApi ?
                        <div className="casino-grid">
                            <ImageGallery allImages={liveCasinoApi} type={'fantacy'}/>
                        </div>
                    : <div className='please-wait-data'>Please wait data is loading...</div>}
    
                </div>
            </div>
        )
    }
    